export const environment = {
    environmentName: 'PPE',
    production: false,
    useLocalMockData: false,
    useLocalMockDataSimulatedDelay: 500,
    useRemoteMockData: false,
    displayDevTools: true,
    displayLanguageSelector: false,
    routerEnableTracing: true,
    debugDisplayFieldJson: false,
    useAdalAuth: false, // Disabled for now, relying solely on SessionId. Will be re-enabled later.
    appInsightsInstrumentationKey: '5cd59a79-b97c-4f71-9294-8a080b12533d',
    bankServiceBaseUrl: 'https://bankservice-dev-afamemexheacgfg7.b02.azurefd.net',
    bankServiceAadAppUri: '249cc3df-0fbd-4f4f-ae0f-d32caedaee3d',
    taxServiceBaseUrl: 'https://payeeonboardingdev30.westus2.cloudapp.azure.com/TaxFabric/PayeeOnboarding.TaxService/',
    taxServiceAadAppUri: '249cc3df-0fbd-4f4f-ae0f-d32caedaee3d',
    basicProfileServiceBaseUrl: 'https://payeeonboardingdev30.westus2.cloudapp.azure.com/BasicFabric/BasicProfileService/',
    basicProfileServiceAadAppUri: '249cc3df-0fbd-4f4f-ae0f-d32caedaee3d',
    complianceServiceBaseUrl: 'https://payeeonboardingdev30.westus2.cloudapp.azure.com/ComplianceFabric/ComplianceService/',
    complianceServiceAadAppUri: '249cc3df-0fbd-4f4f-ae0f-d32caedaee3d',
    adalConfigRedirectUri: 'https://paymentcentralvnextdev.pme-int.microsoft.com/',
    adalConfigLogOutUri: 'https://uatepportal.cloudapp.net',
    adalConfigInstance: 'https://login.windows-ppe.net/', // Default was: https://login.microsoftonline.com/
    adalConfigTenant: 'common', // This is the AAD tenant id where the client app is registered.
    adalConfigClientId: '249cc3df-0fbd-4f4f-ae0f-d32caedaee3d',
    authAppTenantId: 'common',
    authAppClientId: '6955cd20-eedc-42a9-b078-1d73e71912e2',
    authAppRedirectUri: 'https://paymentcentralvnextdev.pme-int.microsoft.com/bank/',
};
